<template>
  <v-app-bar app elevation="0" color="primary" dark>
    <v-app-bar-nav-icon @click="$emit('click-menu')"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ _.result($route, 'meta.title') }}</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'toolbar',
  methods: {
    ...mapActions(['toggleDrawer', 'toggleMini']),
    drawer() {
      this.toggleDrawer()
    },
    mini() {
      this.toggleMini()
    }
  }
}
</script>

<style scoped>
.logo {
  height: 40;
  width: 100;
}
</style>
